import InfoCardType from "../types/InfoCard";
import {FCWithHTMLAttributes} from "../types/reactTypes";
import {ButtonSizes, ButtonVariant} from "./Button";
import LinkButton from "./LinkButton";
import Card from "./Card";

type InfoBoxProps = {
	variant?: string;
	data: InfoCardType;
};

const InfoCard: FCWithHTMLAttributes<InfoBoxProps> = ({
	data,
	children,
	...props
}) => {
	return (
		<Card {...props}>
			<h4>{data.title}</h4>
			<div className="flex flex-col gap-2">
				{data.content}
				{children}
			</div>
			<div>
				{data.buttons.map((button) => {
					return (
						<LinkButton
							id="contact-page-campus-info-card-button"
							key={button.buttonText + button.buttonLink}
							variant={ButtonVariant.OUTLINE_DARK}
							size={ButtonSizes.SMALL}
							href={button.buttonLink}
						>
							{button.buttonText}
						</LinkButton>
					);
				})}
			</div>
		</Card>
	);
};

export default InfoCard;
